function initPoi(element) {
  element.addEventListener('click', function (event) {
    var poiItem = event.target.closest('.js-points-of-interest__item');
    if (poiItem) poiItem.classList.add('points-of-interest__item--visited');
  });
}

export function initPointsOfInterest() {
  var poi = document.getElementsByClassName('js-points-of-interest');
  for (var i = 0; i < poi.length; i++) {
    initPoi(poi[i]);
  }
}

// auto-initialize on page load globally
initPointsOfInterest();